import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { buildUniqueClassName, buildUniqueIdName } from '~/helpers/seo-helpers';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cercle-multicolor-vide.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/checkbox-unchecked.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/checkbox-checked.svg';
const MULTICOLOR_FACET_KEYS = ['n293bc353ebac183d8fae449017e1492f9cd9046', 'Multicolore'];
export default {
  name: 'CategoryFacetItem',
  props: {
    circle: {
      type: Boolean,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    facet: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      buildUniqueClassName,
      buildUniqueIdName,
      colors: {
        default: '',
        gray: '#b5bdc4',
        kraft: '#c4a181',
        dark: '#3c3c3b',
        white: '#ffffff'
      }
    };
  },

  computed: {
    icon() {
      if (this.isMultiColor) return 'cercle-multicolor-vide';
      const icons = this.circle ? ['', ''] : ['checkbox-checked', 'checkbox-unchecked'];
      return this.selected ? icons[0] : icons[1];
    },

    size() {
      return '16';
    },

    color() {
      return this.circle ? this.colors.kraft : this.colors.default;
    },

    colorStyle() {
      return {
        background: this.isMultiColor ? '#ffffff' : "#".concat(this.facet.hex_code),
        border: this.isWhite ? '1px solid #d7d7d7' : ''
      };
    },

    selectedColorStyle() {
      const tagColor = this.isWhite || this.isMultiColor ? '#9b9b9b' : "#".concat(this.facet.hex_code);
      return {
        '--tag-color': tagColor
      };
    },

    iconColorStyle() {
      return this.selected ? _objectSpread({}, this.colorStyle, this.selectedColorStyle) : this.colorStyle;
    },

    isWhite() {
      return this.facet.hex_code === 'ffffff' || this.facet.key === 'Blanc';
    },

    isMultiColor() {
      return MULTICOLOR_FACET_KEYS.includes(this.facet.key);
    }

  }
};